import Header from '../../components/Header'
import Footer from '../../components/Footer'
import CoursesList from '../../components/CoursesList'

function Courses() {
    return (
        <div>
            <Header></Header>
            <CoursesList></CoursesList>
            <Footer></Footer>
        </div>
    )
}

export default Courses